export default function SalaryRenderer({ section }) {

    const rows = section?.fields?.rows || [];

    return (

        <div className="posts-qualification">

            <table className="table">

                <thead>

                    <tr>
                        <th>Post Name</th>
                        <th>Salary</th>
                    </tr>

                </thead>

                <tbody>

                    {rows.map((row,index)=>(

                        <tr key={index}>

                            <td>{row.post_name?.value}</td>

                            <td>{row.salary?.value}</td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}